module.exports = __webpack_public_path__ + "static/media/Pump.71eec1fc.png";